export default "__VITE_ASSET__hMcQqpV$__"